import { Interpolation } from '@angular/compiler';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-stepper-footer',
    templateUrl: './stepper-footer.component.html',
    styleUrls: ['./stepper-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepperFooterComponent {
  @Input() isNextStepDisabled: boolean;
  @Input() previousStepButtonText: string;
  @Input() nextStepButtonText: string;
  @Input() nextStepButtonIcon: boolean = false;
  @Input() isSaveDisplayed: boolean = true;
  @Input() nextStepFullActive: boolean = true;
  @Input() nextStepWithArrow: boolean = false;

  @Output() previousStepClicked = new EventEmitter();
  @Output() nextStepClicked = new EventEmitter();
  @Output() saveAndExitClicked = new EventEmitter();

  get nextStepType() {
    if (this.nextStepFullActive) {
      return 'contained';
    } else {
      return 'outlined';
    }
  }

  onPreviousStepClick() {
    this.previousStepClicked.emit();
  }
  onSaveAndExit() {
    this.saveAndExitClicked.emit();
  }

  onNextStepClick() {
    this.nextStepClicked.emit();
  }
}
